import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import imgUrl from "../../assets/daifukulogo.jpeg";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import Card from "@mui/material/Card";

export const Route = createFileRoute("/_login")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        p: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          my: 4,
          maxWidth: "600px",
          justifyContent: "center",
        }}
      >
        <img src={imgUrl} alt="Daifuku Logo" style={{ maxWidth: "100%" }} />
      </Box>

      <Card sx={{ width: "100%", maxWidth: 500, mb: 2, px: 4, pb: 2 }}>
        <Outlet />
      </Card>
      <Typography variant="caption" sx={{ opacity: 0.5 }}>
        {__APP_VERSION__}
      </Typography>
    </Box>
  );
}
